export default './wheels/stlite_lib-0.1.0-py3-none-any.whl'